<mat-card style="align-items: center; box-shadow: none !important;">
    <mat-card-header>
        <h3>Enviar por Whatsapp  </h3>
        <button (click)="closeDialog()" mat-icon-button style="position:absolute; right: 10px;">
            <mat-icon>close</mat-icon>
        </button>
    </mat-card-header>
    <mat-card-content>
        <p>Selecciona los usuarios a los que deseas enviar la notificación</p>
        <mat-form-field appearance="outline" style="width: 100%;">
            <mat-label>Usuarios</mat-label>
            <mat-select [formControl]="UsersForm" multiple>
                @for (user of UsersList; track user) {
                <mat-option [value]="user.Id">{{user.Name}}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </mat-card-content>
    <mat-card-actions>
        <button mat-flat-button  (click)="sendNotification()" color="primary">Enviar notificación</button>
    </mat-card-actions>
</mat-card>